import { CERBERUS_STATS_FIELDS, CerberusStatsFields } from '@hcs/types';

import {
  DAYS_ON_MARKET_MEDIAN_MOVING_AVG_CONFIG,
  DAYS_ON_MARKET_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/daysOnMarketMedianMovingAvg/daysOnMarketMedianMovingAvg';
import {
  DAYS_ON_MARKET_NOT_CONTRACT_MEDIAN_CONFIG,
  DAYS_ON_MARKET_NOT_CONTRACT_MEDIAN_RENTAL_CONFIG,
} from '../configs/daysOnMarketNotContractMedian';
import {
  DAYS_ON_MARKET_NOT_CONTRACT_MEDIAN_MOVING_AVG_CONFIG,
  DAYS_ON_MARKET_NOT_CONTRACT_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/daysOnMarketNotContractMedianMovingAvg';
import {
  DAYS_TO_CLOSE_MEDIAN_CONFIG,
  DAYS_TO_CLOSE_MEDIAN_RENTAL_CONFIG,
} from '../configs/daysToCloseMedian';
import {
  DAYS_TO_CLOSE_MEDIAN_MOVING_AVG_CONFIG,
  DAYS_TO_CLOSE_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/daysToCloseMedianMovingAvg';
import {
  DAYS_TO_CONTRACT_MEDIAN_CONFIG,
  DAYS_TO_CONTRACT_MEDIAN_RENTAL_CONFIG,
} from '../configs/daysToContractMedian';
import {
  DAYS_TO_CONTRACT_MEDIAN_MOVING_AVG_CONFIG,
  DAYS_TO_CONTRACT_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/daysToContractMedianMovingAvg';
import {
  DAYS_TO_FIRST_PRICE_DROP_MEDIAN_CONFIG,
  DAYS_TO_FIRST_PRICE_DROP_MEDIAN_RENTAL_CONFIG,
} from '../configs/daysToFirstPriceDropMedian';
import {
  DAYS_TO_FIRST_PRICE_DROP_MEDIAN_MOVING_AVG_CONFIG,
  DAYS_TO_FIRST_PRICE_DROP_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/daysToFirstPriceDropMedianMovingAvg';
import { DISPLAY_NAME_CONFIG } from '../configs/displayName';
import { GROSS_YIELD_MEDIAN_CONFIG } from '../configs/grossYieldMedian';
import { HPI_LATEST_MONTH_CONFIG } from '../configs/hpiLatestMonth';
import {
  LISTINGS_CLOSED_COUNT_CONFIG,
  LISTINGS_CLOSED_COUNT_RENTAL_CONFIG,
} from '../configs/listingsClosedCount';
import {
  LISTINGS_CLOSED_COUNT_MOVING_AVG_CONFIG,
  LISTINGS_CLOSED_COUNT_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/listingsClosedCountMovingAvg';
import {
  LISTINGS_NEW_COUNT_CONFIG,
  LISTINGS_NEW_COUNT_RENTAL_CONFIG,
} from '../configs/listingsNewCount';
import {
  LISTINGS_NEW_COUNT_MOVING_AVG_CONFIG,
  LISTINGS_NEW_COUNT_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/listingsNewCountMovingAvg';
import {
  LISTINGS_ON_MARKET_COUNT_MOVING_AVG_CONFIG,
  LISTINGS_ON_MARKET_COUNT_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/listingsOnMarketCountMovingAvg';
import {
  LISTINGS_PRICE_CHANGE_COUNT_CONFIG,
  LISTINGS_PRICE_CHANGE_COUNT_RENTAL_CONFIG,
} from '../configs/listingsPriceChangeCount';
import {
  LISTINGS_PRICE_CHANGE_COUNT_MOVING_AVG_CONFIG,
  LISTINGS_PRICE_CHANGE_COUNT_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/listingsPriceChangeCountMovingAvg';
import {
  LISTINGS_PRICE_DROP_COUNT_CONFIG,
  LISTINGS_PRICE_DROP_COUNT_RENTAL_CONFIG,
} from '../configs/listingsPriceDropCount';
import {
  LISTINGS_PRICE_DROP_COUNT_MOVING_AVG_CONFIG,
  LISTINGS_PRICE_DROP_COUNT_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/listingsPriceDropCountMovingAvg';
import {
  LISTINGS_PRICE_DROP_PERCENT_CONFIG,
  LISTINGS_PRICE_DROP_PERCENT_RENTAL_CONFIG,
} from '../configs/listingsPriceDropPercent';
import {
  LISTINGS_PRICE_DROP_PERCENT_MOVING_AVG_CONFIG,
  LISTINGS_PRICE_DROP_PERCENT_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/listingsPriceDropPercentMovingAvg';
import {
  LISTINGS_REMOVED_COUNT_CONFIG,
  LISTINGS_REMOVED_COUNT_RENTAL_CONFIG,
} from '../configs/listingsRemovedCount';
import {
  LISTINGS_REMOVED_COUNT_MOVING_AVG_CONFIG,
  LISTINGS_REMOVED_COUNT_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/listingsRemovedCountMovingAvg';
import {
  LISTINGS_REMOVED_PERCENT_CONFIG,
  LISTINGS_REMOVED_PERCENT_RENTAL_CONFIG,
} from '../configs/listingsRemovedPercent';
import {
  LISTINGS_REMOVED_PERCENT_MOVING_AVG_CONFIG,
  LISTINGS_REMOVED_PERCENT_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/listingsRemovedPercentMovingAvg';
import {
  LISTINGS_UNDER_CONTRACT_COUNT_CONFIG,
  LISTINGS_UNDER_CONTRACT_COUNT_RENTAL_CONFIG,
} from '../configs/listingsUnderContractCount';
import {
  LISTINGS_UNDER_CONTRACT_COUNT_MOVING_AVG_CONFIG,
  LISTINGS_UNDER_CONTRACT_COUNT_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/listingsUnderContractCountMovingAvg';
import {
  LISTINGS_UNDER_CONTRACT_PERCENT_CONFIG,
  LISTINGS_UNDER_CONTRACT_PERCENT_RENTAL_CONFIG,
} from '../configs/listingsUnderContractPercent';
import {
  LISTINGS_UNDER_CONTRACT_PERCENT_MOVING_AVG_CONFIG,
  LISTINGS_UNDER_CONTRACT_PERCENT_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/listingsUnderContractPercentMovingAvg';
import { MARKET_GRADE_CONFIG } from '../configs/marketGrade';
import {
  MONTHS_OF_SUPPLY_MEDIAN_MOVING_AVG_CONFIG,
  MONTHS_OF_SUPPLY_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/monthsOfSupplyMedianMovingAvg';
import {
  PRICE_CLOSED_MEDIAN_CONFIG,
  PRICE_CLOSED_MEDIAN_RENTAL_CONFIG,
} from '../configs/priceClosedMedian';
import {
  PRICE_CLOSED_MEDIAN_MOVING_AVG_CONFIG,
  PRICE_CLOSED_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/priceClosedMedianMovingAvg';
import {
  PRICE_NEW_LIST_MEDIAN_CONFIG,
  PRICE_NEW_LIST_MEDIAN_RENTAL_CONFIG,
} from '../configs/priceNewListMedian';
import {
  PRICE_NEW_LIST_MEDIAN_MOVING_AVG_CONFIG,
  PRICE_NEW_LIST_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/priceNewListMedianMovingAvg';
import {
  PRICE_ON_MARKET_MEDIAN_MOVING_AVG_CONFIG,
  PRICE_ON_MARKET_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/priceOnMarketMedianMovingAvg';
import {
  PRICE_PER_SQFT_CLOSED_MEDIAN_CONFIG,
  PRICE_PER_SQFT_CLOSED_MEDIAN_RENTAL_CONFIG,
} from '../configs/pricePerSqFtClosedMedian';
import {
  PRICE_PER_SQFT_CLOSED_MEDIAN_MOVING_AVG_CONFIG,
  PRICE_PER_SQFT_CLOSED_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/pricePerSqftClosedMedianMovingAvg';
import {
  PRICE_PER_SQFT_NEW_LIST_MEDIAN_CONFIG,
  PRICE_PER_SQFT_NEW_LIST_MEDIAN_RENTAL_CONFIG,
} from '../configs/pricePerSqftNewListMedian';
import {
  PRICE_PER_SQFT_NEW_LIST_MEDIAN_MOVING_AVG_CONFIG,
  PRICE_PER_SQFT_NEW_LIST_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/pricePerSqftNewListMedianMovingAvg';
import {
  PRICE_PER_SQFT_ON_MARKET_MEDIAN_MOVING_AVG_CONFIG,
  PRICE_PER_SQFT_ON_MARKET_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/pricePerSqFtOnMarketMedianMovingAvg';
import { RPI_LATEST_MONTH_CONFIG } from '../configs/rpiLatestMonth';
import { RPI_RETURN_1_YEAR_CONFIG } from '../configs/rpiReturn1Year';
import {
  SALE_TO_LIST_PRICE_MEDIAN_MOVING_AVG_CONFIG,
  SALE_TO_LIST_PRICE_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/saleToListPriceMedianMovingAvg';
import {
  SALE_TO_LIST_PRICE_ORIGINAL_MEDIAN_CONFIG,
  SALE_TO_LIST_PRICE_ORIGINAL_MEDIAN_RENTAL_CONFIG,
} from '../configs/saleToListPriceOriginalMedian';
import {
  SALE_TO_LIST_PRICE_ORIGINAL_MEDIAN_MOVING_AVG_CONFIG,
  SALE_TO_LIST_PRICE_ORIGINAL_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
} from '../configs/saleToListPriceOriginalMedianMovingAvg';
import { CerberusStatsFieldConfig } from '../types';

import {
  DAYS_ON_MARKET_MEDIAN_CONFIG,
  DAYS_ON_MARKET_MEDIAN_RENTAL_CONFIG,
} from './daysOnMarketMedian';
import {
  LISTINGS_ON_MARKET_COUNT_CONFIG,
  LISTINGS_ON_MARKET_COUNT_RENTAL_CONFIG,
} from './listingsOnMarketCount';
import {
  LISTING_STATS_EVENT_DATE_CONFIG,
  LISTING_STATS_RENTAL_EVENT_DATE_CONFIG,
} from './listingStatsEventDate';
import {
  MONTHS_OF_SUPPLY_MEDIAN_CONFIG,
  MONTHS_OF_SUPPLY_MEDIAN_RENTAL_CONFIG,
} from './monthsOfSupplyMedian';
import { NET_POPULATION_GROWTH_CONFIG } from './netPopulationGrowth';
import { POPULATION_LATEST_MONTH_CONFIG } from './populationLatestMonth';
import {
  PRICE_ON_MARKET_MEDIAN_CONFIG,
  PRICE_ON_MARKET_MEDIAN_RENTAL_CONFIG,
} from './priceOnMarketMedian';
import {
  PRICE_PER_SQFT_ON_MARKET_MEDIAN_CONFIG,
  PRICE_PER_SQFT_ON_MARKET_MEDIAN_RENTAL_CONFIG,
} from './pricePerSqFtOnMarketMedian';
import { RETURN_1_YEAR_FORECAST_CONFIG } from './return1YearForecast';
import { RISK_1_YEAR_LOSS_CONFIG } from './risk1YearLoss';
import {
  SALE_TO_LIST_PRICE_MEDIAN_CONFIG,
  SALE_TO_LIST_PRICE_MEDIAN_RENTAL_CONFIG,
} from './saleToListPriceMedian';

export const CERBERUS_STATS_FIELD_CONFIGS: {
  [F in CerberusStatsFields]: CerberusStatsFieldConfig<F>;
} = {
  [CERBERUS_STATS_FIELDS.daysOnMarketMedian]: DAYS_ON_MARKET_MEDIAN_CONFIG,
  [CERBERUS_STATS_FIELDS.daysOnMarketMedianRental]:
    DAYS_ON_MARKET_MEDIAN_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.daysOnMarketMedianMovingAvg]:
    DAYS_ON_MARKET_MEDIAN_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.daysOnMarketMedianMovingAvgRental]:
    DAYS_ON_MARKET_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.daysOnMarketNotContractMedian]:
    DAYS_ON_MARKET_NOT_CONTRACT_MEDIAN_CONFIG,
  [CERBERUS_STATS_FIELDS.daysOnMarketNotContractMedianRental]:
    DAYS_ON_MARKET_NOT_CONTRACT_MEDIAN_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.daysOnMarketNotContractMedianMovingAvg]:
    DAYS_ON_MARKET_NOT_CONTRACT_MEDIAN_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.daysOnMarketNotContractMedianMovingAvgRental]:
    DAYS_ON_MARKET_NOT_CONTRACT_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.daysToCloseMedian]: DAYS_TO_CLOSE_MEDIAN_CONFIG,
  [CERBERUS_STATS_FIELDS.daysToCloseMedianRental]:
    DAYS_TO_CLOSE_MEDIAN_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.daysToCloseMedianMovingAvg]:
    DAYS_TO_CLOSE_MEDIAN_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.daysToCloseMedianMovingAvgRental]:
    DAYS_TO_CLOSE_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.daysToContractMedian]: DAYS_TO_CONTRACT_MEDIAN_CONFIG,
  [CERBERUS_STATS_FIELDS.daysToContractMedianRental]:
    DAYS_TO_CONTRACT_MEDIAN_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.daysToContractMedianMovingAvg]:
    DAYS_TO_CONTRACT_MEDIAN_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.daysToContractMedianMovingAvgRental]:
    DAYS_TO_CONTRACT_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.daysToFirstPriceDropMedian]:
    DAYS_TO_FIRST_PRICE_DROP_MEDIAN_CONFIG,
  [CERBERUS_STATS_FIELDS.daysToFirstPriceDropMedianRental]:
    DAYS_TO_FIRST_PRICE_DROP_MEDIAN_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.daysToFirstPriceDropMedianMovingAvg]:
    DAYS_TO_FIRST_PRICE_DROP_MEDIAN_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.daysToFirstPriceDropMedianMovingAvgRental]:
    DAYS_TO_FIRST_PRICE_DROP_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.displayName]: DISPLAY_NAME_CONFIG,
  [CERBERUS_STATS_FIELDS.grossYieldMedian]: GROSS_YIELD_MEDIAN_CONFIG,
  [CERBERUS_STATS_FIELDS.hpiLatestMonth]: HPI_LATEST_MONTH_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsClosedCount]: LISTINGS_CLOSED_COUNT_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsClosedCountRental]:
    LISTINGS_CLOSED_COUNT_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsClosedCountMovingAvg]:
    LISTINGS_CLOSED_COUNT_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsClosedCountMovingAvgRental]:
    LISTINGS_CLOSED_COUNT_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsNewCount]: LISTINGS_NEW_COUNT_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsNewCountRental]:
    LISTINGS_NEW_COUNT_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsNewCountMovingAvg]:
    LISTINGS_NEW_COUNT_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsNewCountMovingAvgRental]:
    LISTINGS_NEW_COUNT_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsOnMarketCount]:
    LISTINGS_ON_MARKET_COUNT_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsOnMarketCountRental]:
    LISTINGS_ON_MARKET_COUNT_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsOnMarketCountMovingAvg]:
    LISTINGS_ON_MARKET_COUNT_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsOnMarketCountMovingAvgRental]:
    LISTINGS_ON_MARKET_COUNT_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsPriceChangeCount]:
    LISTINGS_PRICE_CHANGE_COUNT_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsPriceChangeCountRental]:
    LISTINGS_PRICE_CHANGE_COUNT_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsPriceChangeCountMovingAvg]:
    LISTINGS_PRICE_CHANGE_COUNT_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsPriceChangeCountMovingAvgRental]:
    LISTINGS_PRICE_CHANGE_COUNT_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsPriceDropCount]:
    LISTINGS_PRICE_DROP_COUNT_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsPriceDropCountRental]:
    LISTINGS_PRICE_DROP_COUNT_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsPriceDropCountMovingAvg]:
    LISTINGS_PRICE_DROP_COUNT_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsPriceDropCountMovingAvgRental]:
    LISTINGS_PRICE_DROP_COUNT_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsPriceDropPercent]:
    LISTINGS_PRICE_DROP_PERCENT_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsPriceDropPercentRental]:
    LISTINGS_PRICE_DROP_PERCENT_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsPriceDropPercentMovingAvg]:
    LISTINGS_PRICE_DROP_PERCENT_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsPriceDropPercentMovingAvgRental]:
    LISTINGS_PRICE_DROP_PERCENT_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsRemovedCount]: LISTINGS_REMOVED_COUNT_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsRemovedCountRental]:
    LISTINGS_REMOVED_COUNT_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsRemovedCountMovingAvg]:
    LISTINGS_REMOVED_COUNT_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsRemovedCountMovingAvgRental]:
    LISTINGS_REMOVED_COUNT_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsRemovedPercent]:
    LISTINGS_REMOVED_PERCENT_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsRemovedPercentRental]:
    LISTINGS_REMOVED_PERCENT_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsRemovedPercentMovingAvg]:
    LISTINGS_REMOVED_PERCENT_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsRemovedPercentMovingAvgRental]:
    LISTINGS_REMOVED_PERCENT_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.listingStatsEventDate]:
    LISTING_STATS_EVENT_DATE_CONFIG,
  [CERBERUS_STATS_FIELDS.listingStatsEventDateRental]:
    LISTING_STATS_RENTAL_EVENT_DATE_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsUnderContractCount]:
    LISTINGS_UNDER_CONTRACT_COUNT_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsUnderContractCountRental]:
    LISTINGS_UNDER_CONTRACT_COUNT_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsUnderContractCountMovingAvg]:
    LISTINGS_UNDER_CONTRACT_COUNT_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsUnderContractCountMovingAvgRental]:
    LISTINGS_UNDER_CONTRACT_COUNT_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsUnderContractPercent]:
    LISTINGS_UNDER_CONTRACT_PERCENT_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsUnderContractPercentRental]:
    LISTINGS_UNDER_CONTRACT_PERCENT_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsUnderContractPercentMovingAvg]:
    LISTINGS_UNDER_CONTRACT_PERCENT_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.listingsUnderContractPercentMovingAvgRental]:
    LISTINGS_UNDER_CONTRACT_PERCENT_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.marketGrade]: MARKET_GRADE_CONFIG,
  [CERBERUS_STATS_FIELDS.monthsOfSupplyMedian]: MONTHS_OF_SUPPLY_MEDIAN_CONFIG,
  [CERBERUS_STATS_FIELDS.monthsOfSupplyMedianRental]:
    MONTHS_OF_SUPPLY_MEDIAN_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.monthsOfSupplyMedianMovingAvg]:
    MONTHS_OF_SUPPLY_MEDIAN_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.monthsOfSupplyMedianMovingAvgRental]:
    MONTHS_OF_SUPPLY_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.netPopulationGrowth]: NET_POPULATION_GROWTH_CONFIG,
  [CERBERUS_STATS_FIELDS.populationLatestMonth]: POPULATION_LATEST_MONTH_CONFIG,
  [CERBERUS_STATS_FIELDS.priceClosedMedian]: PRICE_CLOSED_MEDIAN_CONFIG,
  [CERBERUS_STATS_FIELDS.priceClosedMedianRental]:
    PRICE_CLOSED_MEDIAN_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.priceClosedMedianMovingAvg]:
    PRICE_CLOSED_MEDIAN_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.priceClosedMedianMovingAvgRental]:
    PRICE_CLOSED_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.priceNewListMedian]: PRICE_NEW_LIST_MEDIAN_CONFIG,
  [CERBERUS_STATS_FIELDS.priceNewListMedianRental]:
    PRICE_NEW_LIST_MEDIAN_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.priceNewListMedianMovingAvg]:
    PRICE_NEW_LIST_MEDIAN_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.priceNewListMedianMovingAvgRental]:
    PRICE_NEW_LIST_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.priceOnMarketMedian]: PRICE_ON_MARKET_MEDIAN_CONFIG,
  [CERBERUS_STATS_FIELDS.priceOnMarketMedianRental]:
    PRICE_ON_MARKET_MEDIAN_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.priceOnMarketMedianMovingAvg]:
    PRICE_ON_MARKET_MEDIAN_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.priceOnMarketMedianMovingAvgRental]:
    PRICE_ON_MARKET_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.pricePerSqftClosedMedianMovingAvg]:
    PRICE_PER_SQFT_CLOSED_MEDIAN_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.pricePerSqftClosedMedianMovingAvgRental]:
    PRICE_PER_SQFT_CLOSED_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.pricePerSqftNewListMedian]:
    PRICE_PER_SQFT_NEW_LIST_MEDIAN_CONFIG,
  [CERBERUS_STATS_FIELDS.pricePerSqftNewListMedianRental]:
    PRICE_PER_SQFT_NEW_LIST_MEDIAN_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.pricePerSqftNewListMedianMovingAvg]:
    PRICE_PER_SQFT_NEW_LIST_MEDIAN_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.pricePerSqftNewListMedianMovingAvgRental]:
    PRICE_PER_SQFT_NEW_LIST_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.pricePerSqftOnMarketMedian]:
    PRICE_PER_SQFT_ON_MARKET_MEDIAN_CONFIG,
  [CERBERUS_STATS_FIELDS.pricePerSqftOnMarketMedianRental]:
    PRICE_PER_SQFT_ON_MARKET_MEDIAN_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.pricePerSqftClosedMedian]:
    PRICE_PER_SQFT_CLOSED_MEDIAN_CONFIG,
  [CERBERUS_STATS_FIELDS.pricePerSqftClosedMedianRental]:
    PRICE_PER_SQFT_CLOSED_MEDIAN_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.pricePerSqftOnMarketMedianMovingAvg]:
    PRICE_PER_SQFT_ON_MARKET_MEDIAN_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.pricePerSqftOnMarketMedianMovingAvgRental]:
    PRICE_PER_SQFT_ON_MARKET_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.return1YearForecast]: RETURN_1_YEAR_FORECAST_CONFIG,
  [CERBERUS_STATS_FIELDS.risk1YearLoss]: RISK_1_YEAR_LOSS_CONFIG,
  [CERBERUS_STATS_FIELDS.rpiLatestMonth]: RPI_LATEST_MONTH_CONFIG,
  [CERBERUS_STATS_FIELDS.rpiReturn1Year]: RPI_RETURN_1_YEAR_CONFIG,
  [CERBERUS_STATS_FIELDS.saleToListPriceMedian]:
    SALE_TO_LIST_PRICE_MEDIAN_CONFIG,
  [CERBERUS_STATS_FIELDS.saleToListPriceMedianRental]:
    SALE_TO_LIST_PRICE_MEDIAN_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.saleToListPriceMedianMovingAvg]:
    SALE_TO_LIST_PRICE_MEDIAN_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.saleToListPriceMedianMovingAvgRental]:
    SALE_TO_LIST_PRICE_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.saleToListPriceOriginalMedian]:
    SALE_TO_LIST_PRICE_ORIGINAL_MEDIAN_CONFIG,
  [CERBERUS_STATS_FIELDS.saleToListPriceOriginalMedianRental]:
    SALE_TO_LIST_PRICE_ORIGINAL_MEDIAN_RENTAL_CONFIG,
  [CERBERUS_STATS_FIELDS.saleToListPriceOriginalMedianMovingAvg]:
    SALE_TO_LIST_PRICE_ORIGINAL_MEDIAN_MOVING_AVG_CONFIG,
  [CERBERUS_STATS_FIELDS.saleToListPriceOriginalMedianMovingAvgRental]:
    SALE_TO_LIST_PRICE_ORIGINAL_MEDIAN_MOVING_AVG_RENTAL_CONFIG,
};
